import axios from 'axios'
import { i18n } from '@/plugins/i18n'

// O backend limita quantas renderizações de PDF (Chromium) podem acontecer ao
// mesmo tempo; quando não há vaga ele responde 503. Nesse caso mostramos uma
// mensagem amigável de "tente de novo em instantes" em vez do erro genérico.
export function reportErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error) && error.response?.status === 503) {
    return i18n.global.t('globals.report_busy')
  }

  return fallback
}
